


export default {
    showHeaderDelay: 3000
}